import React from "react";
import SubscribeToEmailList from "../../organisms/Common/SubscribeToEmailList";
import htmlDecode from "../../../utils/htmlDecode";

function BlogPost(props) {
    return (
        <div>
            <div className="col-md-12 px-0">
                {/*  */}
                <div
                    className="hero-banner col-md-12 px-0"
                    style={{
                        backgroundImage: `url(${props.header_image_file})`,
                        minHeight: "15rem",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                    }}
                >
                    <div
                        style={{
                            height: "100%",
                            width: "100%",
                            backgroundColor: "rgba(0,0,0, 0.65)",
                            position: "absolute",
                        }}
                    ></div>
                    <div className="container">
                        <div className="row">
                            <div
                                className="col-md-12 pt-7"
                                style={{ zIndex: "1" }}
                            >
                                <h1 className="text-gray-400">{props.title}</h1>
                                <p className="mb-0 text-gray-500">
                                    <span className="mr-2">
                                        <i className="fas fa-calendar text-secondary"></i>
                                    </span>
                                    <span className="">{props.date}</span>{" "}
                                </p>
                                <p className="mb-0 text-gray-500">
                                    <span className="mr-2">
                                        <i className="fas fa-user text-secondary"></i>
                                    </span>
                                    <span className="">
                                        {props.author_name}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* // */}
                <div className="card card-tile mb-1">
                    <div className="card-body py-2 pl-0 pr-0">
                        <section className="">
                            <div className="container z-2">
                                <div className="row justify-content-center">
                                    <div className="card shadow-soft border-light">
                                        <div className="card-body pl-3 pb-2">
                                            <div className="row">
                                                <div className="col-12 px-lg-6 pt-4">
                                                    <div
                                                        className="rich-text"
                                                        dangerouslySetInnerHTML={{
                                                            __html: htmlDecode(
                                                                props.body_with_images
                                                            ),
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <hr />
                                            <span className="text-bolder">
                                                Posted Under:
                                            </span>

                                            {/* // */}
                                            <p className="mb-0 text-gray-500">
                                                {props.blog_categories.map(
                                                    (tag) => (
                                                        <a
                                                            className="badge badge-tertiary text-white"
                                                            href={`/blog/categories/${tag.slug}`}
                                                        >
                                                            {tag.name}
                                                        </a>
                                                    )
                                                )}
                                            </p>

                                            {/* // */}
                                            <div className="col-lg-12 col-md-12 mt-5 px-0">
                                                <a
                                                    className="analytics-view-plans-link btn btn-dark btn-block"
                                                    href="/plans/"
                                                >
                                                    Browse our House Plans
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
            <SubscribeToEmailList />
        </div>
    );
}

export default BlogPost;
